import {
  LOGIN_EMAIL,
  SET_SUBSCRIPTION_STATUS,
  SET_STREAM,
} from '../actions/Types'

function user (state = {}, action) {

  const { params } = action

  switch (action.type) {

    case LOGIN_EMAIL :
      return {
        ...state,
        user_info: params.user_info,
        login_token: params.login_token,
        createdAt: params.createdAt,
      }

    // case ACTIVATE_TEXT :
    //   return {
    //     ...state,
    //     text_id: params.text_id,
    //   }

    case SET_STREAM :
      return {
        ...state,
        streams: params.streams,
      }

    // case UPDATE_TRANSCRIPT :
    //
    //   let new_transcript = params.new_transcript
    //   if (!state.update_transcripts) {
    //     state.update_transcripts = {}
    //   }
    //   state.update_transcripts[new_transcript._id] = new_transcript.kanji
    //
    //   return {
    //     ...state,
    //     update_transcripts: state.update_transcripts,
    //   }

    // case AUDIO_PLAYING :
    //   return {
    //     ...state,
    //     playing: params.playing,
    //   }

    // case AUDIO_SET_TIME :
    //   return {
    //     ...state,
    //     currentTime: params.currentTime,
    //   }

    case SET_SUBSCRIPTION_STATUS:
      
      return {
        ...state,
        subscription_status: params.subscription_status,
      }

    default :
      return state
  }
}

export default user
